import React from 'react';
import colors from '../../../../../tailwind.colors';
import { Close } from '../../../../../static/icons/close';
import { Typography } from '../../../atoms/typography/Typography';
import styled from 'styled-components';

const Bubble = styled.div`
  background-color: ${colors.primary[50]};
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  height: 120px;
  padding: 5px 8px;
  position: relative;
  border-width: 1px;
  border-color: ${colors.primary[100]};
  margin-bottom: 8px;
  margin-top: 8px;
  box-sizing: border-box;

  &:before {
    content: '';
    position: absolute;
    top: -webkit-calc(100% - 7.5px);
    top: calc(100% - 7.5px);
    left: ${(props) => `${props.left}px` ?? '15px'};
    height: 15px;
    width: 15px;
    background: ${colors.primary[50]};
    transform: rotate(45deg);
    border-bottom: inherit;
    border-right: inherit;
    box-shadow: inherit;
  }
`;

const SystemCardBubble = ({ position, title, description, closePopover }) => {
  return (
    <Bubble left={position}>
      <span className="w-fit self-end global-hover" onClick={closePopover}>
        <Close />
      </span>
      <Typography fontVariant={'h8'} textAlign={'left'} className={'px-2'}>
        {title}
      </Typography>
      <Typography
        fontVariant={'sm'}
        textAlign={'left'}
        className={'!text-customGray-700 px-2'}
      >
        {description}
      </Typography>
    </Bubble>
  );
};

export default SystemCardBubble;
